import { render } from "./SideMenu.vue?vue&type=template&id=114459a8&lang=pug"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script